import { render, staticRenderFns } from "./SponsorDashboard.vue?vue&type=template&id=6f067f24&"
import script from "./SponsorDashboard.vue?vue&type=script&lang=js&"
export * from "./SponsorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SponsorDashboard.vue?vue&type=style&index=0&id=6f067f24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports